import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AdalService } from './../azure-authentication/adal.service';

@Component({
    template: '<div>Please wait...</div>'
})

export class OAuthCallbackComponent implements OnInit {

    constructor(private router: Router, private adalService: AdalService) { }

    ngOnInit() {
        if (!this.adalService.userInfo) {
            this.router.navigate(['login']);
        } else {
            this.router.navigate(['home']);
        }
    }
} 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/login-callback/oauth-callback.component.ts